<template>
  <div id="mechanism" class="table-section">
    <el-card class="box-card" shadow="never">
      <el-button type="primary"  @click="addSMSTemplateDialog = true">新增短信模板</el-button>
    </el-card>
    <div class="table-section">
      <el-table :data="tableData" :header-row-style="headerRowStyle" max-height="550px" border highlight-current-row
        style="width: 100%">
        <el-table-column prop="name" label="模板名称">
          <template slot-scope="scope">
            <span v-if="!scope.row.isEdit">{{ scope.row.name }}</span>
            <el-input v-else v-model.trim="scope.row.name" />
          </template>
        </el-table-column>
        <el-table-column label="是否用于催收">

          <template slot-scope="scope">
            <span v-if="!scope.row.isEdit">{{ scope.row.type === 1 ? '是' : '否' }}</span>
            <el-select v-else v-model="scope.row.type">
              <el-option :value="1" label="是" />
              <el-option :value="0" label="否" />
            </el-select>
          </template>
        </el-table-column>
        <el-table-column prop="code" label="模板代码">

          <template slot-scope="scope">
            <span v-if="!scope.row.isEdit">{{ scope.row.code }}</span>
            <el-input v-else v-model.trim="scope.row.code" />
          </template>
        </el-table-column>
        <el-table-column prop="content" label="模板内容" width="700px">

          <template slot-scope="scope">
            <span v-if="!scope.row.isEdit">{{ scope.row.content }}</span>
            <el-input v-else v-model.trim="scope.row.content" />
          </template>
        </el-table-column>
        <el-table-column prop="createdAt" label="创建时间" />
        <el-table-column label="操作">

          <template slot-scope="scope">
            <el-button v-if="!scope.row.isEdit" type="text" @click="scope.row.isEdit = true">修改</el-button>
            <el-button v-else type="text" @click="SMSTemplateEdit(scope.row)">确认</el-button>
          </template>
        </el-table-column>
      </el-table>
    </div>
    <div class="pagination-section">
      <el-pagination :page-sizes="[5, 10, 15, 20]" :page-size="pageSize" :total="total"
        layout="total, prev, pager, next, sizes" @current-change="changePage" @size-change="sizeChange" />
    </div>
    <!-- 新增短信模板 -->
    <el-drawer :visible.sync="addSMSTemplateDialog" title="新增模板">
      <el-form :model="addSMSTemplateForm" label-width="100px">
        <el-form-item label="模板名称">
          <el-input v-model.trim="addSMSTemplateForm.name" />
        </el-form-item>
        <el-form-item label="是否用于催收">
          <el-select v-model="addSMSTemplateForm.type">
            <el-option :value="1" label="是" />
            <el-option :value="0" label="否" />
          </el-select>
        </el-form-item>
        <el-form-item label="模板代码">
          <el-input v-model.trim="addSMSTemplateForm.code" />
        </el-form-item>
        <el-form-item label="模板内容">
          <el-input v-model.trim="addSMSTemplateForm.content" />
        </el-form-item>
        <el-form-item>
          <el-button @click="addSMSTemplateDialog = false">取 消</el-button>
          <el-button type="primary" @click="confirmaddCustomGroup">确 定</el-button>
        </el-form-item>
      </el-form>
    </el-drawer>
  </div>
</template>

<script>
import { SMSTemplateList, SMSTemplateEdit } from '@/api/template.js'
import { mapGetters } from 'vuex'
const moment = require('moment')

export default {
  name: 'SMStemplate',
  data() {
    return {
      headerRowStyle: {
        'background-color': '#6584b4'
      },
      tableData: [],
      pageSize: 10,
      page: 1,
      total: 0,
      addSMSTemplateDialog: false,
      addSMSTemplateForm: {}
    }
  },
  computed: {
    ...mapGetters([
      'currentUser'
    ])
  },
  created() {
    this.SMSTemplateList()
  },
  methods: {
    /**
     * 获取列表
     */
    async SMSTemplateList() {
      const { data: { total, records } } = await SMSTemplateList(this.page, this.pageSize)
      records.forEach(item => {
        item.isEdit = false
        if (item.createdAt) item.createdAt = moment(item.createdAt).format('YYYY-MM-DD HH:mm:ss')
      })
      this.$set(this, 'tableData', records)
      this.$set(this, 'total', total)
    },
    /**
     * 修改
     */
    async SMSTemplateEdit(row) {
      const { code } = await SMSTemplateEdit(row)
      if (code === '00') {
        this.$message.success('操作成功')
        row.isEdit = false
        this.SMSTemplateList()
      }
    },
    /**
     * 新增
     */
    async confirmaddCustomGroup() {
      if (!this.addSMSTemplateForm.name || !this.addSMSTemplateForm.code || !this.addSMSTemplateForm.content) return this.$message.error('请填写完整信息')
      this.addSMSTemplateForm.crTemplateId = ''
      this.addSMSTemplateForm.type = 0
      const { code } = await SMSTemplateEdit(this.addSMSTemplateForm)
      if (code === '00') {
        this.$message.success('操作成功')
        this.addSMSTemplateDialog = false
        this.addSMSTemplateForm = {}
        this.SMSTemplateList()
      }
    },
    changePage(currentPage) {
      this.page = currentPage
      this.SMSTemplateList()
    },
    sizeChange(size) {
      this.page = 1
      this.pageSize = size
      this.SMSTemplateList()
    }
  }
}
</script>

<style lang="scss">
.cell {
  text-align: center !important;
}

.el-table {
  thead {

    tr,
    th {
      background-color: #eee;
    }
  }

  tr,
  th {
    text-align: center !important;
  }
}

.table-section {
  margin-top: 20px;
}

.pagination-section {
  margin-top: 20px;
  text-align: center;
}
</style>
